import * as React from 'react';
import b_ from 'b_';

import './index.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
}

const b = b_.with('idea-top-card-factoid');

export const Factoid: React.FC<Props> = ({ title, children, ...props }) => (
  <div className={b()} {...props}>
    <div className={b('title')} data-testid="title">
      {title}
    </div>
    <div className={b('value')} data-testid="value">
      {children}
    </div>
  </div>
);
